import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyMarkiPremium() {
  return <ArticleLayout article={articlesBySlug['kakobuy-marki-premium-lista']} />;
}